import { render, staticRenderFns } from "./LabelState.vue?vue&type=template&id=1ba7b3f9"
import script from "./LabelState.vue?vue&type=script&lang=js"
export * from "./LabelState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports